import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import { BaseApiService as BaseApiService$1 } from '@prv/apis';
import * as i1 from '@angular/common/http';
import * as i2 from '@nexa/configuration';
import { map, switchMap } from 'rxjs/operators';

/**
 * Servicio encargado de interactuar con el microservicio ScheduleHistory
 */
class ScheduleApiService extends BaseApiService$1 {
    /**
     * Crea una nueva instancia de @see ScheduleApiService
     * @param httpClient Service HttpClient
     * @param configuration Service NexaConfigurationService
     */
    constructor(httpClient, configuration) {
        super(httpClient, configuration, 'schedule-history', 'Schedule');
    }
    /**
     * Metodo encargado de consultar todos los registros asociados a un contacto por número de documento
     * @param args Argumentos para la ejecución del servicio
     * @returns Retorna un array de tipo @see ScheduleDto con la información de los registros
     */
    getByNumberDocument(args) {
        return this.getUri((uri) => this.httpClient.post(`${uri}/GetByNumberDocument`, args));
    }
    /**
     * Metodo encargado de consultar todos los registros asociados a un contacto por número de documento
     * que se encuentra en los claim del identity server
     * @returns Retorna un objeto de tipo @see DataExternalDto con la información encriptada del objeto
     */
    getByNumberDocumentAuth() {
        return this.getUri((uri) => this.httpClient.get(`${uri}/GetByNumberDocument`));
    }
    /**
     * Metodo encargado de verificar si existe un agendamiento con una tipología y una lista de estados de agendamiento específicos
     * @param args Argumentos para la consulta de información
     * @returns Retorna True si existen registros con los parámetros espeficiados, de lo contrario retorna False
     * @example
     * // Is any records by typology and scheduling states
     * this.service.anyTypologyByStates('1', 1, 1, '1,2').suscribe(x => console.log(x))
     */
    anyTypologyByStates(args) {
        return this.getUri((uri) => this.httpClient.post(`${uri}/AnyTypologyByStates`, args));
    }
    /**
     * Consulta el agendamiento actual
     * @param args Argumentos para la consulta de información
     */
    nowTypologyNodeByStates(args) {
        const data = {
            idTypology: null,
            idNode: -1,
            stateIds: '',
            filterSinceNow: null,
            ...args
        };
        if (data.idTypology !== null) {
            if (data.filterSinceNow !== null) {
                return this.getUri((uri) => this.httpClient.get(`${uri}/NowTypologyNodeByStates/${data.idNode}/${data.stateIds}?idTypology=${data.idTypology}&filterSinceNow=${data.filterSinceNow}`));
            }
            else {
                return this.getUri((uri) => this.httpClient.get(`${uri}/NowTypologyNodeByStates/${data.idNode}/${data.stateIds}?idTypology=${data.idTypology}`));
            }
        }
        else {
            if (data.filterSinceNow !== null) {
                return this.getUri((uri) => this.httpClient.get(`${uri}/NowTypologyNodeByStates/${data.idNode}/${data.stateIds}?filterSinceNow=${data.filterSinceNow}`));
            }
            else {
                return this.getUri((uri) => this.httpClient.get(`${uri}/NowTypologyNodeByStates/${data.idNode}/${data.stateIds}`));
            }
        }
    }
    /**
     * Metodo encargado de consultar el estado de una cita
     * @param args Argumentos para la consulta de información
     * @returns Retorna un array con los estados de agendamiento
     */
    getScheduleAssigned(args) {
        const params = {
            ...args
        };
        return this.getUri(uri => this.httpClient.get(`${uri}/GetScheduleAssigned`, { params }));
    }
    /**
     * Metodo encargado de consultar las citas desde un funcionario por diferentes fechas
     * @param args Argumentos de la consulta de la información
     * @returns Retorna un tipo @see ScheduleDto con la infomación de los registros
     */
    GetByServantForDate(args) {
        const data = {
            idServantGestorAssigned: 0,
            dateInitial: new Date(),
            dateEnd: new Date(),
            ...args
        };
        const ScheduleAll = `${data.idServantGestorAssigned}/${data.dateInitial}/${data.dateEnd}`;
        return this.getUri(uri => this.httpClient.get(`${uri}/GetByServantForDate/${ScheduleAll}`));
    }
    /**
     * Metodo encargado de consultar las citas de un asistente tercero por fecha
     * @param args Argumentos de la consulta de la información
     * @returns Retorna un tipo @see ScheduleDto con la infomación de los registros
     */
    getActiveSchedulesByThirds(args) {
        const data = {
            numberDocumentAssistent: "1234",
            typeDocument: 0,
            selectedDate: new Date(),
            ...args
        };
        const query = `${data.typeDocument}/${data.numberDocumentAssistent}/${data.selectedDate}`;
        return this.getUri(uri => this.httpClient.get(`${uri}/GetActiveSchedulesByThirds/${query}`));
    }
}
ScheduleApiService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: ScheduleApiService, deps: [{ token: i1.HttpClient }, { token: i2.NexaConfigurationService }], target: i0.ɵɵFactoryTarget.Injectable });
ScheduleApiService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: ScheduleApiService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: ScheduleApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: i2.NexaConfigurationService }]; } });

/**
 * Servicio encargado de interactuar con el microservicio ScheduleHistory
 */
class ScheduleHistoryApiService extends BaseApiService$1 {
    /**
     * Crea una nueva instancia de @see ScheduleHistoryApiService
     * @param httpClient Service HttpClient
     * @param configuration Service NexaConfigurationService
     */
    constructor(httpClient, configuration) {
        super(httpClient, configuration, 'schedule-history', 'ScheduleHistory');
    }
}
ScheduleHistoryApiService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: ScheduleHistoryApiService, deps: [{ token: i1.HttpClient }, { token: i2.NexaConfigurationService }], target: i0.ɵɵFactoryTarget.Injectable });
ScheduleHistoryApiService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: ScheduleHistoryApiService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: ScheduleHistoryApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: i2.NexaConfigurationService }]; } });

/**
 * Implementa todas las operaciones base a nivel de Api
 */
class BaseApiService {
    /**
     * Crea una nueva instancia de @see BaseApiService
     * @param httpClient Service HttpClient
     * @param configurationService Service NexaConfigurationService
     * @param api Name Api Configuration
     * @param service Nombre del controlador o complemento del servicio base (https://domain.com/api/{service}/....)
     */
    constructor(httpClient, configurationService, api, service) {
        this.configurationService = configurationService;
        this.api = api;
        this.service = service;
        this.httpClient = httpClient;
    }
    /**
     * Flujo encargado obtner la api
     * @param observable Flujo a ejecutar
     * @example
     * // Uri to generate http request
     * this.service.getUri((api) => { ... }).suscribe(x => console.log(x))
     */
    getUri(fn) {
        return this.configurationService.configuration$.pipe(map((x) => x.apis[this.api]), map((api) => `${api}/${this.service}`), switchMap((api) => fn(api)));
    }
}

/**
 * Servicio encargado de retornar la disponibilidad de citas dsiponibles
 */
class ScheduleAssignedApiService extends BaseApiService {
    /**
     * Crea una nueva instancia de @see ScheduleAssignedApiService
     * @param httpClient Service HttpClient
     * @param configuration Service NexaConfigurationService
     */
    constructor(httpClient, configuration) {
        super(httpClient, configuration, 'schedule-history', 'Schedule');
    }
    /***
      * Metodo encargado de consultar horarios disponibles asociados a un Nodo
      * @param args Argumentos para la consulta de información
      * @returns Returns un array con la información de los nodos @see AssignedScheduleDto
      */
    getScheduleNodeServantAssigned(args) {
        if (!args?.dateIni) {
            delete args?.dateIni;
        }
        if (!args?.idServant) {
            delete args?.idServant;
        }
        const params = {
            ...args
        };
        return this.getUri(uri => this.httpClient.get(`${uri}/GetScheduleNodeServant`, { params }));
    }
}
ScheduleAssignedApiService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: ScheduleAssignedApiService, deps: [{ token: i1.HttpClient }, { token: i2.NexaConfigurationService }], target: i0.ɵɵFactoryTarget.Injectable });
ScheduleAssignedApiService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: ScheduleAssignedApiService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: ScheduleAssignedApiService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: i2.NexaConfigurationService }]; } });

/**
 * Servicio encargado de interactuar con el microservicio ScheduleHistory
 */
class TwilioApiService extends BaseApiService$1 {
    /**
     * Crea una nueva instancia de @see ScheduleApiService
     * @param httpClient Service HttpClient
     * @param configuration Service NexaConfigurationService
     */
    constructor(httpClient, configuration) {
        super(httpClient, configuration, 'schedule-history', 'Twilio');
    }
    /**
     * Metodo encargado de consumir el servicio de Twilio para el envio de OTPs
     * @param RequestSendOtpDto Numero de telefono al que se va a enviar el OTP
     * @returns Retorna una operacion asincrona con el codigo del OTP generado y enviado
     * @example
     * this.service.sendOtpAsync(RequestSendOtpDto).subscribe((x) => console.log(x));
     */
    sendOtpAsync(requestSendOtpDto) {
        const response = this.getUri((url) => this.httpClient.post(`${url}/SendOtp`, requestSendOtpDto, { responseType: 'text' }));
        return response;
    }
    /**
     * Metodo encargado de consumir el servicio de Twilio para consultar el estado de un OTP
     * @param requestCheckOtpDto Contiene el Codigo que resibe el asistente y el Numero de telefono que se va a validar el OTP
     * @returns Retorna una operacion asincrona con el codigo del OTP generado y enviado
     * @example
     * this.service.checkOtpAsync(RequestCheckOtpDto).subscribe((x) => console.log(x));
     */
    checkOtpAsync(requestCheckOtpDto) {
        const response = this.getUri((url) => this.httpClient.post(`${url}/CheckOtp`, requestCheckOtpDto, { responseType: 'text' }));
        return response;
    }
    /**
     * Método encargado de consumir el servicio de Twilio para consultar el estado de un OTP desde una aplicación externa
     * @param data Objeto con la cadena que contiene el código que recibe el asistente y el número de teléfono que se va a validar el OTP
     * @returns Retorna una operacion asincrona con el codigo del OTP generado y enviado
     * @example
     * this.service.checkOtpAsync(RequestCheckOtpDto).subscribe((x) => console.log(x));
     */
    checkOtpExternal(data) {
        const response = this.getUri((url) => this.httpClient.post(`${url}/CheckOtpExternal`, data));
        return response;
    }
}
TwilioApiService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: TwilioApiService, deps: [{ token: i1.HttpClient }, { token: i2.NexaConfigurationService }], target: i0.ɵɵFactoryTarget.Injectable });
TwilioApiService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: TwilioApiService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: TwilioApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: i2.NexaConfigurationService }]; } });

/*
 * Public API Surface of schedule-history
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ScheduleApiService, ScheduleAssignedApiService, ScheduleHistoryApiService, TwilioApiService };
